/** Consistent channel colors used across all intervention analytics charts */
import palette from '../../../../theme/palette'

const CHANNEL_COLORS = {
  whatsapp:       '#25D366',
  calls_futwork:  palette.chart.red[0],
  calls_futworkAI: palette.chart.yellow[0],
  sms:            palette.chart.blue[0],
  automated_rule: palette.chart.violet[0],
  manual:         palette.grey[500],
}

/** Human-readable labels for each channel */
const CHANNEL_LABELS = {
  whatsapp:       'WhatsApp',
  calls_futwork:  'Calls (Futwork)',
  calls_futworkAI:'Calls (FutworkAI)',
  sms:            'SMS',
  automated_rule: 'Automated Rule',
  manual:         'Manual Action',
}

/** Call outcome colors */
const OUTCOME_COLORS = {
  reattempt:        palette.success.main,
  rto:              palette.error.main,
  wrong_number:     palette.grey[400],
  escalation:       palette.warning.main,
  no_answer:        palette.grey[300],
  language_barrier:  '#7B1FA2',
  engagedNoTerminalAction: '#1976D2',
  other:            '#607D8B',
}

const OUTCOME_LABELS = {
  reattempt:        'Reattempt',
  rto:              'RTO Initiated',
  wrong_number:     'Wrong Number',
  escalation:       'Escalation',
  no_answer:        'No Answer',
  language_barrier:  'Language Barrier',
  engagedNoTerminalAction: 'Engaged · No Terminal Action',
  other:            'Other',
}

export { CHANNEL_COLORS, CHANNEL_LABELS, OUTCOME_COLORS, OUTCOME_LABELS }
